type ValidationDetail = {
	property?: string;
	constraints?: Record<string, string> | null;
	children?: ValidationDetail[] | null;
};

const flattenDetail = (detail: ValidationDetail): string[] => {
	const own = detail.constraints ? Object.values(detail.constraints) : [];
	const nested = (detail.children ?? []).flatMap(flattenDetail);

	if (own.length || nested.length) return [...own, ...nested];

	return detail.property ? [`Invalid ${detail.property}`] : [];
};

const toMessages = (raw: unknown): string[] => {
	if (raw === null || raw === undefined) return [];
	if (typeof raw === 'string') return raw.trim() ? [raw.trim()] : [];
	if (Array.isArray(raw)) return raw.flatMap(toMessages);
	if (typeof raw === 'object') return flattenDetail(raw as ValidationDetail);

	return [String(raw)];
};

/** Flattens a Nest error `message` (string, string[], or validation objects) to one line. */
export const flattenApiMessage = (raw: unknown, separator = ', '): string =>
	toMessages(raw).join(separator);

/**
 * gateway-game's ValidationPipe answers a 400 with `message` as an array of
 * `{ property, constraints, children }` OBJECTS — not a string. Putting that straight into
 * the store means React later renders an object as a child ("Objects are not valid as a
 * React child") and the whole app unmounts, so every API error is flattened to one string
 * before it leaves the saga.
 */
export const getApiErrorMessage = (error: any, fallback: string): string => {
	const data = error?.response?.data;
	// `data.error` is only the exception's short description ('Validation failed'), so it is
	// a fallback for `data.message`, never an addition to it.
	const message = flattenApiMessage(data?.message);

	if (message) return message;

	return flattenApiMessage(data?.error) || flattenApiMessage(error?.message) || fallback;
};
